var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 255.1 255.1",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0Dark{fill:#5b5466}.st1Dark{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 127.6,
    r: 121.6,
    className: "st0Dark"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.525,189.876c3.54,0.472,7.168,0.718,10.861,0.718c39.32,0,71.194-27.794,71.194-62.077 c0-34.285-31.875-62.077-71.194-62.077c-2.638,0-5.244,0.126-7.805,0.369c19.504,12.884,32.401,35.204,32.401,60.579 C142.98,154.066,128.728,177.365,107.525,189.876z M127.6,204.963c42.727,0,77.363-34.636,77.363-77.363 S170.327,50.237,127.6,50.237S50.237,84.873,50.237,127.6S84.873,204.963,127.6,204.963z",
    className: "st1Dark"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.db620f393eba5193bb25532df5b346e6.svg";
export { ForwardRef as ReactComponent };